import React from 'react';
import { Navigate } from 'react-router-dom';
import { useLicense } from '../context/LicenseContext';

const hasFeatureAccess = (features, requiredFeature) => {
  if (!features || !Array.isArray(features)) {
    return false;
  }
  return features.includes(requiredFeature);
};

export function LicenseProtectedRoute({ children, feature }) {
  const { licenseInfo, isLoading, error } = useLicense();

  // Show loading state
  if (isLoading) {
    return <div>Loading license information...</div>;
  }

  // If there's no license info or there's an error, redirect to license activation
  if (!licenseInfo || error) {
    return <Navigate to="/license-upgrade" replace />;
  }

  // Check if the required feature is enabled in the license
  const features = licenseInfo.features || {};
  const hasFeature = feature ? features[feature]?.enabled : true;

  if (!hasFeature) {
    return <Navigate to="/license-upgrade" replace />;
  }

  return children;
} 